import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const S = {
  font: "'Sora', system-ui, sans-serif",
  heading: "'Fraunces', Georgia, serif",
};

export default function ExamSuccessPage() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div style={{ background: 'var(--soleil-cream)', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 24px' }}>
      <div style={{ background: '#fff', borderRadius: 20, border: '1px solid var(--soleil-sand)', maxWidth: 520, width: '100%', textAlign: 'center', overflow: 'hidden' }}>
        <div style={{ height: 4, background: 'linear-gradient(90deg, var(--soleil-gold), var(--soleil-sienna))' }} />
        <div style={{ padding: '48px 36px 40px' }}>
          <div style={{ fontSize: 56, marginBottom: 20 }}>🎉</div>
          <h1 style={{ fontFamily: S.heading, fontSize: 28, fontWeight: 600, color: 'var(--soleil-ink)', marginBottom: 12 }}>
            {isRTL ? 'تم الدفع بنجاح!' : 'Payment Successful!'}
          </h1>
          <p style={{ fontFamily: S.font, fontSize: 15, color: 'var(--soleil-sub)', lineHeight: 1.7, marginBottom: 32, maxWidth: 400, margin: '0 auto 32px' }}>
            {isRTL
              ? 'تم تأكيد دفعتك لامتحان الشهادة. سيتواصل معك فريقنا قريباً لتنسيق موعد الامتحان.'
              : 'Your certification exam payment is confirmed. Our team will contact you shortly to coordinate your exam scheduling.'}
          </p>

          <div style={{ background: 'var(--soleil-gold-pale)', borderRadius: 14, padding: '20px 24px', marginBottom: 28 }}>
            <div style={{ fontFamily: S.font, fontSize: 12, fontWeight: 700, color: 'var(--soleil-mut)', letterSpacing: '0.1em', marginBottom: 8 }}>
              {isRTL ? 'الخطوات التالية' : 'NEXT STEPS'}
            </div>
            <div style={{ fontFamily: S.font, fontSize: 14, color: 'var(--soleil-ink)', lineHeight: 1.8, textAlign: 'left' }}>
              {isRTL ? (
                <>
                  1. ستصلك رسالة تأكيد عبر البريد الإلكتروني<br/>
                  2. سيتواصل معك فريقنا لتحديد موعد الامتحان<br/>
                  3. ستتلقى تعليمات الامتحان قبل الموعد المحدد
                </>
              ) : (
                <>
                  1. You will receive a confirmation email<br/>
                  2. Our team will reach out to schedule your exam<br/>
                  3. You will receive exam instructions before your date
                </>
              )}
            </div>
          </div>

          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <Link to="/dashboard" style={{
              fontFamily: S.font, fontSize: 14, fontWeight: 700, color: '#fff',
              background: '#b8860b', padding: '12px 28px', borderRadius: 50,
              textDecoration: 'none', display: 'inline-block',
            }}>
              {isRTL ? 'لوحة التحكم' : 'Go to Dashboard'}
            </Link>
            <Link to="/exams" style={{
              fontFamily: S.font, fontSize: 14, fontWeight: 600, color: 'var(--soleil-ink)',
              background: '#fff', padding: '12px 28px', borderRadius: 50, border: '1px solid var(--soleil-sand)',
              textDecoration: 'none', display: 'inline-block',
            }}>
              {isRTL ? 'تصفح الامتحانات' : 'Browse Exams'}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
